module.exports = __webpack_public_path__ + "static/media/N-Mall-003.4bd9754e.webp";